const has = (v) => (Array.isArray(v) ? v.length > 0 : v != null && String(v).trim() !== "");

const TECH_REQUIRED = [
  ["Full name", (m) => (m.name || "").trim().length >= 2],
  ["Profile photo", (m) => has(m.avatar_path)],
  ["City & country", (m) => has(m.city) && has(m.country)],
  ["Specialization", (m) => has(m.specializations)],
  ["Years of experience", (m) => m.experience_years != null],
  ["About me", (m) => (m.bio || "").trim().length >= 20],
];

const TECH_OPTIONAL = [
  ["Headline", (m) => has(m.headline)],
  ["Certificates", (m) => has(m.certificates)],
  ["Work experience", (m) => has(m.experience)],
  ["Skills", (m) => has(m.skills)],
  ["CV (PDF)", (m) => has(m.cv_path)],
  ["Languages", (m) => has(m.languages)],
];

const COMPANY_ITEMS = [
  ["Company logo", (m) => has(m.avatar_path)],
  ["City & country", (m) => has(m.city) && has(m.country)],
  ["About the company", (m) => (m.bio || "").trim().length >= 20],
  ["Website", (m) => has(m.website)],
  ["Phone", (m) => has(m.phone)],
];

const exempt = (me) => me.access_role === "admin" || me.demo;

export const needsWizard = (me) => me.role === "technician" && !exempt(me) && TECH_REQUIRED.some(([, ok]) => !ok(me));

export function profileStrength(me) {
  if (exempt(me)) return { percent: 100, missing: [] };
  const items = me.role === "technician" ? [...TECH_REQUIRED, ...TECH_OPTIONAL] : COMPANY_ITEMS;
  const missing = items.filter(([, ok]) => !ok(me)).map(([label]) => label);
  return { percent: Math.round(((items.length - missing.length) / items.length) * 100), missing };
}
